export const openPostWindow = (url: string, title: string, param: string, data: Record<string, any> = {}) => {
  const w = window.open(url, 'postWindow', param);
  w!.onload = function () { w!.document.title = title };

  const form = document.createElement<'form'>('form');
  
  form.setAttribute('method', 'post');
  form.setAttribute('action', url);
  form.setAttribute('target', 'postWindow');

  Object.entries(data).forEach(([key, value]) => {
    const input = document.createElement<'input'>('input');
    input.type = 'hidden';
    input.name = key;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();

  document.body.removeChild(form);
}

export default ({openPostWindow});